import React, { Component } from "react";
import styled from "styled-components";

import * as geom from "js/core/utilities/geom";
import { app } from "js/namespaces";

const Container = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
`;

const DragSelection = styled.div.attrs(({ bounds }) => ({
    style: {
        ...bounds.toObject()
    }
}))`
    position: absolute;
    border: 1px dotted #50bbe6;
`;

export class DragSelectionManagerRollover extends Component {
    static defaultState = {
        isDragging: false,
        dragStartPoint: null,
        dragSelectionBounds: null
    }

    constructor(props) {
        super(props);

        this.containerRef = React.createRef();

        this.state = { ...DragSelectionManagerRollover.defaultState };
    }

    componentDidMount() {
        const { dragState } = this.props;

        if (dragState) {
            this.startDrag();
        }
    }

    componentDidUpdate(prevProps) {
        const { dragState } = this.props;

        if (!prevProps.dragState && dragState) {
            this.startDrag();
        }
    }

    setStateAsync = state => new Promise(resolve => this.setState(state, resolve));

    startDrag = async () => {
        const {
            dragState: {
                startDragEvent
            }
        } = this.props;

        if (!startDragEvent) {
            throw new Error("startDrag() cannot be initialized without a startDragEvent");
        }

        app.isDragging = true;
        app.isDraggingItem = true;

        const containerBounds = geom.Rect.FromBoundingClientRect(this.containerRef.current.getBoundingClientRect());

        await this.setStateAsync({
            containerBounds,
            dragStartPosition: new geom.Point(startDragEvent.pageX, startDragEvent.pageY),
            isDragging: true
        });

        document.addEventListener("mousemove", this.handleDrag);
        document.addEventListener("mouseup", this.handleDragEnd);
    }

    handleDrag = async event => {
        window.requestAnimationFrame(async ts => {
            if (this.dragFrameHandledAt === ts) {
                return;
            }
            this.dragFrameHandledAt = ts;

            const { selectionLayerController, canvasController } = this.props;
            const { containerBounds, dragStartPosition, isDragging } = this.state;
            if (!isDragging) {
                return;
            }

            const left = Math.min(dragStartPosition.x, event.pageX);
            const top = Math.min(dragStartPosition.y, event.pageY);
            const width = Math.abs(event.pageX - dragStartPosition.x);
            const height = Math.abs(event.pageY - dragStartPosition.y);

            const dragSelectionBounds = new geom.Rect(left, top, width, height).offset(-containerBounds.left, -containerBounds.top);

            await this.setStateAsync({ dragSelectionBounds });

            const elements = selectionLayerController.getElementsForDragSelection(dragSelectionBounds.spaceScale(1 / canvasController.canvas.getScale()));
            if (event.shiftKey) {
                await selectionLayerController.setSelectedElements([...selectionLayerController.selectedElements, ...elements]);
            } else {
                await selectionLayerController.setSelectedElements(elements);
            }
        });
    }

    handleDragEnd = async event => {
        const {
            selectionLayerController
        } = this.props;

        app.isDragging = false;
        app.isDraggingItem = false;

        document.removeEventListener("mousemove", this.handleDrag);
        document.removeEventListener("mouseup", this.handleDragEnd);

        await this.setStateAsync({ ...DragSelectionManagerRollover.defaultState });

        await selectionLayerController.unregisterDragSelection();
    }

    render() {
        const {
            isDragging,
            dragSelectionBounds
        } = this.state;

        return (<Container ref={this.containerRef}>
            {isDragging && dragSelectionBounds &&
                <DragSelection bounds={dragSelectionBounds} />
            }
        </Container>);
    }
}
